import * as React from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import { default as MaterialThemeProvider } from '@material-ui/styles/ThemeProvider';
import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      'Oxygen',
      'Ubuntu',
      'Cantarell',
      '"Fira Sans"',
      '"Droid Sans"',
      '"Helvetica Neue"',
      'sans-serif',
    ].join(','),
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '#root': {
          height: '100%',
        },
        body: {
          height: '100%',
          backgroundColor: '#F2F2F6',
        },
        html: {
          height: '100%',
        },
        form: {
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
    MuiInputLabel: {
      root: {
        width: '100%',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: 'rgba(26, 17, 24, 0.6)',
        fontSize: '18px',
        lineHeight: '22px',
        '&$focused': {
          color: '#3AD4DC'
        },
        '&$shrink': {
          fontSize: '14px',
          lineHeight: '16px',
        },
      },
    },
    MuiInput: {
      root: {
        fontSize: '18px',
        lineHeight: '22px',
        color: '#000',
      },
      underline: {
        '&::before': {
          borderBottom: '1px solid #e0e0e0',
        },
        '&::after': {
          borderBottom: '1px solid #000',
        },
        '&:hover:not(.Mui-disabled)::before': {
          borderBottom: '1px solid #e0e0e0',
        },
      },
    },
    MuiCircularProgress: {
      colorPrimary: { color: 'rgba(0, 0, 0, 0.54)' },
    },
  },
});

type ThemeProviderProps = {};

export const ThemeProvider: React.FC<React.PropsWithChildren<ThemeProviderProps>> = ({ children, ...rest }) => (
  <MaterialThemeProvider theme={theme} {...rest}>
    <CssBaseline />
    {children}
  </MaterialThemeProvider>
);
